import styled from "styled-components";

interface ContainerProps {
    color: "green" | "red";
}

export const Container = styled.div<ContainerProps>`
    display: flex;
    width: auto;
    height: 20px;
    color: ${props => props.color};
}
`;

export const IconArea = styled.div`
    width: auto;
    height: 20px;
    margin-top: 1px;
}
`;

export const NumberArea = styled.div`
    width: auto;
    height: 20px;
    margin-left: 2px;
}
`;
